import { Injectable, inject } from '@angular/core';
import { PetDataLayerRepository } from '../../../domain/repositories/tagging/PetDataLayer.repository';
import { MascotaDataLayer, PetDataLayerItem } from '../../../domain/interfaces/tagging/datalayer.interface';
import { PetDataLayerService } from '../../services/tagging/PetDataLayer.service';

@Injectable({ providedIn: 'root' })
export class PetDataLayerRepositoryImplementation extends PetDataLayerRepository {
  private readonly petDataLayerService = inject(PetDataLayerService);

  logPetEvent(
    step: number,
    item: PetDataLayerItem,
    pantalla: string,
    userId: string,
    mascotas: MascotaDataLayer[] = [],
    additionalData: Record<string, string | number> = {},
  ): void {
    this.petDataLayerService.logPetEvent(step, item, pantalla, userId, mascotas, additionalData);
  }

  logError404(item: PetDataLayerItem, userId: string): void {
    this.petDataLayerService.logError404(item, userId);
  }

  logError500(item: PetDataLayerItem, userId: string, pantalla?: string): void {
    this.petDataLayerService.logError500(item, userId, pantalla);
  }
}
